export default {"src":"/_next/static/media/logo.5526e8dd.svg","height":76,"width":246,"blurWidth":0,"blurHeight":0};